<template>
  <div class="input-wrapper">
    <input
      :style="marginZero ? { marginBottom: 0 } : {}"
      :id="id"
      :class="{disabled: isDisable, default: true, error: !isValidate && isFirstCheck}"
      v-model="showValue"
      :placeholder="placeholder"
      @input="changedInput"
      @change="changedInput"
      :disabled="isDisable"
      :maxlength="maxlength"
      @focus="(event) => { changeFirstCheck(); onFocus(event); }"
      @blur="(e) => { changeFirstCheck(e); onBlur(e); }"
      @keydown="(e) => { onKeyDown(e); }"
      :type="type"
      :pattern="pattern"
      :tabindex="useFocus ? 0 : -1"
    />
    <p v-show="!isValidate && isFirstCheck" class="text">{{errorMessage}}</p>
  </div>
</template>

<script>
export default {
  name: 'VInput',
  props: {
    marginZero: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    },
    value: {
      type: String
    },
    onChanged: {
      type: Function,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    },
    errorMessage: {
      type: String,
      required: false
    },
    isValidate: {
      type: Boolean,
      default: true
    },
    isDisable: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      default: 255
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    onBlur: {
      type: Function,
      default: () => {}
    },
    onFocus: {
      type: Function,
      default: () => {}
    },
    onFirstCheck: {
      type: Function,
      default: () => {}
    },
    onKeyDown: {
      type: Function,
      default: () => {}
    },
    pattern: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'string'
    },
    useFocus: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    changeFirstCheck() {
      if (!this.isFirstCheck) {
        this.isFirstCheck = true
      }
    },

    changedInput(event) {
      this.onChanged(event)
      this.changeFirstCheck()
      this.showValue = this.value
    }
  },
  watch: {
    value(value) {
      // console.log(value)
      this.showValue = value
    },

    showValue(value) {
      // console.log(value)
      this.$emit('input', value)
    }
  },
  mounted() {
    this.onFirstCheck()
  },
  data() {
    return {
      showValue: this.value,
      isFirstCheck: this.isFirst
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.input-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;

  .default {
    width: 100%;
    background-color: $background-gray;
    padding: 14px 12px 13px 12px;
    box-sizing: border-box;
    font-size: 14px;
    letter-spacing: -0.35px;
    color: $gray;
    border: 1px solid $background-gray;
    border-radius: 4px;
    border-collapse: collapse;
    margin-bottom: 4px;

    &::placeholder {
      color: $light-gray-9;
    }
  }

  .error {
    border: 1px solid $red;
  }

  .text {
    margin-top: 4px;
    padding-left: 12px;
    font-size: 14px;
    letter-spacing: -0.35px;
    color: $red;
  }

  .disabled {
    border: 1px solid $light-gray-5;
    background-color: $light-gray-5 !important;
    color: $gray-3 !important;
    opacity: 1 !important;
  }
}
</style>
